import styled from 'styled-components';

import { Tabs as TabsComponent } from 'shared/blocks/one-shop/shared/components/Tabs/component/Tabs/Tabs';

export const Tabs = styled(TabsComponent)`
  margin-bottom: var(--spacing-m);
`;
